import React, { PropTypes } from 'react'
import cx from 'classnames'

import './ProfileSidebar.scss'
import ProfileSidebarMenuItem from './components/ProfileSidebarMenuItem'
import * as paths from 'utils/paths'

const ProfileSidebar = (props) => {
  const {
    isOpen,
    userId
  } = props

  const sidebarClassName = cx(
    'ProfileSidebar',
    {
      'ProfileSidebar--expanded': isOpen
    }
  )

  return (
    <div className={sidebarClassName}>
      <nav className='ProfileSidebar-links'>
        <ProfileSidebarMenuItem
          icon='cleaning'
          to={paths.userNextServices(userId)}
          label='Mis Servicios'
          className='ProfileSidebarMenuItem-services'
          />

        <a
          href={paths.userEditProfile(userId)}
          className='ProfileSidebarMenuItem ProfileSidebar-profile' >
          <span className='ProfileSidebarMenuItem-icon icon-user' />
          <span className='ProfileSidebarMenuItem-label'>Editar tu perfil</span>
        </a>

        <a
          href={paths.freeServices(userId)}
          className='ProfileSidebarMenuItem ProfileSidebar-promos' >
          <span className='ProfileSidebarMenuItem-icon icon-logo' />
          <span className='ProfileSidebarMenuItem-label'>Promociones</span>
        </a>

        <a
          href={paths.userInvoices(userId)}
          className='ProfileSidebarMenuItem ProfileSidebar-invoice' >
          <span className='ProfileSidebarMenuItem-icon icon-invoice' />
          <span className='ProfileSidebarMenuItem-label'>Facturación</span>
        </a>

        <a
          href={paths.logout()}
          className='ProfileSidebarMenuItem ProfileSidebar-logout' >
          <span className='ProfileSidebarMenuItem-icon' />
          <span className='ProfileSidebarMenuItem-label'>Cerrar sesión</span>
        </a>

      </nav>
    </div>
  )
}

ProfileSidebar.displayName = 'ProfileSidebar'
ProfileSidebar.propTypes = {
  isOpen: PropTypes.bool,
  userId: PropTypes.string.isRequired
}
ProfileSidebar.defaultProps = {
  isOpen: false
}

export default ProfileSidebar



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/components/ProfileSidebar/ProfileSidebar.js